
const Pulse = ({ className = '' }) => (
  <div className={`animate-pulse bg-gray-200 rounded ${className}`.trim()} />
);

const SummarySkeleton = () => (
  <div className="p-4 rounded-xl border border-gray-200 bg-gray-50">
    <div className="flex items-start gap-3">
      <div className="w-8 h-8 rounded-full bg-gray-200 animate-pulse flex-shrink-0" />
      <div className="flex-1 min-w-0 space-y-2">
        <Pulse className="h-3 w-11/12" />
        <Pulse className="h-3 w-10/12" />
        <Pulse className="h-3 w-7/12" />
      </div>
    </div>
  </div>
);

const QuickActionsSkeleton = () => (
  <div>
    <Pulse className="h-3 w-24 mb-3" />
    <div className="flex flex-wrap gap-2">
      <Pulse className="h-11 w-28 rounded-full" />
      <Pulse className="h-11 w-32 rounded-full" />
      <Pulse className="h-11 w-24 rounded-full" />
    </div>
  </div>
);

const CommunityPostSkeletonCard = () => (
  <li className="bg-white rounded-xl border border-gray-200 overflow-hidden">
    <div className="flex gap-3 p-4">
      <Pulse className="w-16 h-16 rounded-lg flex-shrink-0" />
      <div className="flex-1 min-w-0 space-y-2">
        <Pulse className="h-3 w-9/12" />
        <Pulse className="h-3 w-11/12" />
        <Pulse className="h-3 w-1/2 mt-1" />
      </div>
    </div>
  </li>
);

const CommunityPostsSkeleton = () => (
  <div>
    <Pulse className="h-3 w-32 mb-3" />
    <ul className="space-y-3">
      <CommunityPostSkeletonCard />
      <CommunityPostSkeletonCard />
      <CommunityPostSkeletonCard />
    </ul>
  </div>
);

const PlaceSkeletonCard = () => (
  <li className="bg-white rounded-xl border border-gray-200 overflow-hidden">
    <div className="flex items-start gap-3 p-4">
      <Pulse className="w-12 h-12 rounded-full flex-shrink-0" />
      <div className="flex-1 min-w-0 space-y-2">
        <Pulse className="h-3 w-8/12" />
        <Pulse className="h-3 w-10/12" />
        <div className="flex gap-2 mt-3">
          <Pulse className="h-9 w-20 rounded-lg" />
          <Pulse className="h-9 w-24 rounded-lg" />
        </div>
      </div>
    </div>
  </li>
);

const PlacesSkeleton = () => (
  <div>
    <Pulse className="h-3 w-36 mb-3" />
    <ul className="space-y-3">
      <PlaceSkeletonCard />
      <PlaceSkeletonCard />
      <PlaceSkeletonCard />
    </ul>
  </div>
);

const AISearchSkeleton = () => (
  <div className="max-w-md sm:max-w-2xl mx-auto" aria-hidden="true">
    <div className="space-y-6">
      <SummarySkeleton />
      <QuickActionsSkeleton />
      <CommunityPostsSkeleton />
      <PlacesSkeleton />
    </div>
  </div>
);

export default AISearchSkeleton;
